var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _path10, _g3, _path11, _path12, _g4, _path13, _path14, _g5, _path15, _path16, _g6, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g7, _g8, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g9, _g10, _path31, _path32, _path33, _path34, _g11, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g12, _path51, _g13, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_291_3005)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.496 504.007C399.74 504.007 510.999 392.748 510.999 255.503C510.999 118.259 399.74 7 262.496 7C125.251 7 13.9922 118.259 13.9922 255.503C13.9922 392.748 125.251 504.007 262.496 504.007Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350.341 389.021C343.88 386.873 339.052 381.388 337.685 374.643L328.278 328.084L247.798 330.942L237.893 379.453C236.509 386.252 242.065 393.068 248.455 395.57L282.127 408.741C288.393 411.191 295.12 412.167 301.812 411.599L372.973 405.511C375.049 405.333 376.718 403.7 376.967 401.606C377.215 399.511 378.671 397.15 376.682 396.493L350.341 389.021Z",
    fill: "#97A6B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.142 386.199C344.68 384.086 339.852 378.672 338.503 372.016L329.113 326.043L250.604 328.865L240.717 376.755C239.333 383.465 242.989 390.192 249.379 392.66L283.016 405.671C289.264 408.085 295.992 409.061 302.683 408.493L373.773 402.476C375.85 402.298 377.518 400.683 377.767 398.606C378.015 396.529 376.755 394.577 374.785 393.938L351.142 386.199Z",
    fill: "url(#paint0_linear_291_3005)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M479.652 295.725V86.9468C479.652 82.6689 476.12 79.0124 471.807 78.8526L113.128 64.4217C107.678 64.2087 103.188 67.9718 103.188 72.7998V303.535L479.652 295.725Z",
    fill: "url(#paint1_linear_291_3005)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M464.068 89.2724L123.316 76.5632C118.346 76.3857 114.281 79.8293 114.281 84.2313V104.91V285.146C114.281 289.637 118.435 293.205 123.511 293.063L463.926 283.389C467.99 283.265 471.31 279.892 471.31 275.881V115.134V96.692C471.292 92.7514 468.044 89.4144 464.068 89.2724Z",
    fill: "url(#paint2_linear_291_3005)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.188 303.535V349.615C103.188 354.443 107.661 358.206 113.128 357.975L471.807 342.816C476.138 342.639 479.652 338.982 479.652 334.705V294.376L103.188 303.535Z",
    fill: "url(#paint3_linear_291_3005)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.797 268.763C411.332 258.805 386.961 279.111 365.785 263.136C341.911 245.119 361.205 210.506 339.124 190.111C308.452 161.782 247.124 205.714 220.481 179.017C202.163 160.664 223.765 131.269 208.269 100.348C200.388 84.6215 185.602 73.9181 167.674 66.6227L113.11 64.4217C107.661 64.2087 103.17 67.9718 103.17 72.7998V303.535V349.615C103.17 354.443 107.643 358.206 113.11 357.975L471.789 342.817C476.12 342.639 479.635 338.982 479.635 334.705V304.92C467.014 282.572 453.08 272.916 440.797 268.763Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.079 275.117L171.721 294.927C171.721 294.927 154.911 280.514 156.402 262.852C159.456 226.819 127.683 226.659 114.405 224.618C94.3654 221.512 80.3249 210.862 91.9691 192.33C105.122 171.367 72.9763 153.191 39.8721 152.854C7.47792 152.517 -10.6096 94.7395 59.5571 89.0239C101.465 85.6159 116.056 123.903 128.02 141.494C139.983 159.084 168.331 145.203 171.561 173.071C174.33 196.857 166.928 219.488 186.01 226.216C205.091 232.943 214.623 247.143 207.079 275.117Z",
    fill: "url(#paint4_linear_291_3005)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_291_3005",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 88,
    width: 199,
    height: 207
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.079 275.117L171.721 294.927C171.721 294.927 154.911 280.514 156.402 262.852C159.456 226.819 127.683 226.659 114.405 224.618C94.3654 221.512 78.0351 210.045 94.7026 191.727C111.352 173.426 72.9763 153.191 39.8721 152.854C7.47792 152.517 -10.6096 94.7395 59.5571 89.0239C101.465 85.6159 116.056 123.903 128.02 141.494C139.983 159.084 168.331 145.203 171.561 173.071C174.33 196.857 166.928 219.488 186.01 226.216C205.091 232.943 214.623 247.143 207.079 275.117Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_291_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.608 286.975L192.791 287.259C192.614 286.762 175.29 236.6 143.108 192.082C113.466 151.043 64.7944 106.526 1.26625 127.436L1 126.619C29.2761 117.318 57.0198 119.963 83.4321 134.518C104.537 146.144 124.861 165.332 143.818 191.585C176.071 236.227 193.43 286.478 193.608 286.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2242 141.085L93.4254 141.405C82.6865 115.028 53.6826 85.2607 53.3809 84.959L53.9844 84.3555C54.2861 84.6572 83.4143 114.549 94.2242 141.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3498 131.873C42.4468 130.293 23.17 150.955 22.9925 151.168L22.3535 150.6C22.5488 150.387 42.074 129.424 76.3853 131.039L76.3498 131.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.563 222.328C134.5 191.798 81.7996 209.992 81.3026 210.205L80.9121 209.442C81.3736 209.175 134.891 190.946 163.202 221.743L162.563 222.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45 207.294L153.634 207.542C145.664 182.301 161.479 153.031 161.639 152.729L162.385 153.138C162.225 153.439 146.587 182.408 154.45 207.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.898 279.431C181.148 266.331 155.516 266.438 155.25 266.438V265.586C156.315 265.568 181.609 265.461 190.608 278.952L189.898 279.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.958 267.485L185.159 267.769C180.988 256.036 190.502 235.037 193.626 228.133C194.07 227.156 194.443 226.322 194.496 226.145L195.33 226.322C195.277 226.553 195.028 227.121 194.407 228.47C191.301 235.321 181.893 256.089 185.958 267.485Z",
    fill: "white"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.286 375.158C220.517 375.193 220.766 375.211 220.996 375.246C235.09 376.879 250.799 376.169 268.07 371.696C271.371 370.596 274.673 369.478 277.992 368.377C278.436 359.626 277.265 351.213 266.188 351.159C248.988 351.071 240.415 323.38 241.871 312.269C243.663 298.512 247.16 266.402 220.553 265.852C198.418 265.408 184.023 269.632 174.934 243.966C165.846 218.299 146.818 206.211 123.618 214.713C99.2118 223.659 69.0542 196.537 51.9074 213.613C22.0515 243.38 71.1487 291.394 119.252 295.335C167.373 299.275 147.155 322.138 152.267 343.828C159.243 373.436 196.803 355.632 210.577 364.011C215.263 366.851 218.298 370.862 220.286 375.158Z",
    fill: "url(#paint5_linear_291_3005)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_291_3005",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 207,
    width: 237,
    height: 185
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.854 391.559L277.975 375.193C278.809 366.584 278.56 351.23 266.188 351.177C248.988 351.088 240.415 323.398 241.871 312.286C243.663 298.53 247.16 266.42 220.553 265.869C198.418 265.425 184.023 269.65 174.934 243.983C165.846 218.316 146.818 206.228 123.618 214.731C99.2118 223.677 69.0542 196.555 51.9074 213.63C22.0515 243.397 71.1487 291.412 119.252 295.352C167.373 299.293 147.155 322.155 152.267 343.846C159.243 373.453 196.803 355.65 210.577 364.028C221.405 370.596 223.517 383.429 223.854 391.559Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_291_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.769 375.335L247.852 374.767C205.837 295.654 125.641 237.327 38.5587 222.541L38.3457 223.748C125.073 238.463 204.932 296.56 246.769 375.335Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.162 334.173L221.334 333.818C211.287 300.074 232.339 265.177 232.552 264.84L231.505 264.201C231.309 264.556 209.956 299.897 220.162 334.173Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.64 360.993L239.51 360.124C214.305 334.865 150.883 349.101 150.262 349.243L150.528 350.432C151.167 350.308 213.914 336.214 238.64 360.993Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.705 273.502L157.646 272.721C139.434 251.048 144.28 207.897 144.333 207.471L143.108 207.329C143.055 207.755 138.156 251.438 156.705 273.502Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.448 245.048L107.767 243.859C76.5979 235.516 38.4704 256.604 38.0977 256.817L38.7012 257.882C39.0739 257.669 76.7754 236.83 107.448 245.048Z",
    fill: "#FCFDFE"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M309.624 399.369C304.938 389.038 299.595 373.063 301.796 354.443C304.334 333.072 314.541 327.729 321.694 304.405C331.9 271.106 313.937 249.716 327.019 238.463C333.391 232.978 344.237 231.789 351.443 235.818C371.998 247.338 373.187 307.085 345.444 333.462C332.894 345.39 320.806 345.444 312.002 360.087C304.228 373.01 306.659 388.683 309.624 399.369Z",
    fill: "url(#paint6_linear_291_3005)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_291_3005",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 233,
    width: 66,
    height: 167
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M309.624 399.369C304.938 389.038 299.595 373.063 301.796 354.443C304.334 333.072 314.541 327.729 321.694 304.405C331.9 271.106 313.937 249.716 327.019 238.463C333.391 232.978 344.237 231.789 351.443 235.818C371.998 247.338 373.187 307.085 345.444 333.462C332.894 345.39 320.806 345.444 312.002 360.087C304.228 373.01 306.659 388.683 309.624 399.369Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_291_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.564 372.637L304.191 372.584C304.848 367.933 305.913 363.318 307.351 358.863C310.67 348.621 314.913 342.728 320.273 335.273C323.752 330.427 327.71 324.942 332.113 317.221C340.366 302.772 342.869 297.749 344.733 289.886C348.425 274.336 346.153 261.006 344.467 254.438C342.07 245.119 337.917 236.475 332.13 228.7L332.432 228.47C338.254 236.28 342.425 244.977 344.839 254.332C346.526 260.935 348.816 274.336 345.106 289.974C343.224 297.873 340.721 302.914 332.45 317.398C328.03 325.138 324.072 330.64 320.593 335.486C315.25 342.906 311.025 348.781 307.724 358.97C306.286 363.407 305.221 368.004 304.564 372.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.526 279.111L346.491 278.792C343.828 257.74 317.7 253.249 317.434 253.214L317.487 252.841C317.753 252.876 343.899 257.367 346.81 278.419C347.929 277.585 352.402 274.017 356.165 268.071C360.123 261.805 364.046 251.51 360.247 238.126L360.62 238.02C364.454 251.545 360.478 261.947 356.484 268.301C352.153 275.171 346.828 278.898 346.775 278.934L346.526 279.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.822 314.877C338.894 314.877 334.598 313.493 334.509 313.457L334.35 313.404L334.367 313.244C336.036 302.115 332.699 294.411 329.61 289.903C326.273 285.022 322.493 282.75 322.457 282.732L322.652 282.395C322.812 282.483 337.9 291.696 334.776 313.138C336.586 313.688 353.768 318.428 366.46 306.127L366.726 306.411C359.697 313.244 351.283 314.877 344.822 314.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.634 336.977C326.291 336.977 321.676 333.711 321.605 333.675L321.499 333.586L321.534 333.462C325.137 321.96 316.493 304.689 316.404 304.511L316.742 304.334C316.83 304.511 325.475 321.782 321.942 333.427C323.185 334.243 334.474 341.024 353.165 331.794L353.343 332.131C345.905 335.823 339.604 336.977 334.634 336.977Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M299.31 395.553C296.879 386.837 294.536 373.081 300.411 359.91C310.653 336.924 334.403 341.61 353.857 316.067C369.548 295.459 362.395 281.561 380.678 267.006C383.731 264.574 399.866 251.243 413.533 256.728C421.237 259.817 424.734 267.503 425.39 268.94C435.331 290.72 416.16 328.617 387.902 348.053C371.678 359.218 365.785 356.786 336.621 370.933C319.492 379.24 306.996 388.896 299.31 395.553Z",
    fill: "url(#paint7_linear_291_3005)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_291_3005",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 296,
    y: 255,
    width: 133,
    height: 141
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.31 395.553C296.879 386.837 294.536 373.081 300.411 359.91C310.653 336.924 334.403 341.61 353.857 316.067C369.548 295.459 362.395 281.561 380.678 267.006C383.731 264.574 399.866 251.243 413.533 256.728C421.237 259.817 424.734 267.503 425.39 268.94C435.331 290.72 416.16 328.617 387.902 348.053C371.678 359.218 365.785 356.786 336.621 370.933C319.492 379.24 306.996 388.896 299.31 395.553Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_291_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.908 406.504L297.518 406.469C299.63 384.778 306.464 369.619 317.806 361.401C323.362 357.389 328.03 356.342 332.965 355.224C338.272 354.035 343.739 352.81 350.591 347.574C357.229 342.497 359.342 338.077 362.004 332.486C364.401 327.445 367.383 321.179 374.66 312.464C381.032 304.831 385.878 301.05 390.138 297.713C394.753 294.11 398.41 291.252 402.28 284.844C408.616 274.354 411.137 261.503 409.752 246.663L410.143 246.628C411.527 261.556 409.007 274.478 402.617 285.057C398.694 291.536 395.02 294.412 390.369 298.033C386.127 301.352 381.299 305.115 374.944 312.712C367.702 321.392 364.738 327.64 362.341 332.646C359.661 338.29 357.549 342.746 350.822 347.875C343.917 353.147 338.396 354.39 333.054 355.597C328.154 356.697 323.539 357.727 318.037 361.703C306.783 369.85 300.003 384.92 297.908 406.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.151 299.542L388.204 299.293C388.275 298.991 394.594 268.55 382.436 257.562L382.702 257.278C394.417 267.857 389.234 296.151 388.63 299.116C419.605 296.577 433.343 271.78 433.467 271.514L433.805 271.692C433.663 271.94 419.764 297.057 388.4 299.506L388.151 299.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.322 324.711C375.406 324.711 367.809 322.297 367.738 322.279L367.578 322.226L367.595 322.066C370.169 306.268 364.063 284.844 363.992 284.631L364.365 284.524C364.418 284.737 370.524 306.091 368.004 321.96C369.175 322.315 376.772 324.445 387.245 324.32C397.7 324.196 413.249 321.693 427.929 310.582L428.159 310.884C413.391 322.066 397.753 324.569 387.227 324.693C386.925 324.711 386.624 324.711 386.322 324.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.647 362.147C364.045 362.147 356.27 360.762 350.856 359.342C342.46 357.159 337.721 354.443 337.668 354.407L337.49 354.301L337.597 354.123C347.697 338.645 340.614 315.659 340.526 315.428L340.898 315.304C340.969 315.534 348.052 338.521 338.023 354.159C339.993 355.224 358.329 364.596 386.889 360.869L386.942 361.241C382.221 361.898 377.766 362.147 373.647 362.147Z",
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.281 369.46C306.642 366.514 315.322 362.36 326.629 359.839C346.74 355.331 355.1 360.443 364.241 353.272C373.72 345.852 369.247 336.871 380.501 328.67C381.441 327.978 393.512 319.44 402.884 324.286C409.451 327.694 411.191 335.823 411.99 339.64C415.149 354.461 409.682 375.779 393.228 384.637C377.607 393.032 359.981 386.003 354.39 383.731C344.574 379.737 342.657 375.495 332.646 371.75C320.487 367.206 308.932 368.093 301.281 369.46Z",
    fill: "url(#paint8_linear_291_3005)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_291_3005",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 322,
    width: 112,
    height: 67
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.281 369.46C306.642 366.514 315.322 362.36 326.629 359.839C346.74 355.331 355.1 360.443 364.241 353.272C373.72 345.852 369.247 336.871 380.501 328.67C381.441 327.978 393.512 319.44 402.884 324.286C409.451 327.694 411.191 335.823 411.99 339.64C415.149 354.461 409.682 375.779 393.228 384.637C377.607 393.032 359.981 386.003 354.39 383.731C344.574 379.737 342.657 375.495 332.646 371.75C320.487 367.206 308.932 368.093 301.281 369.46Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_291_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.861 372.194L296.666 371.856C309.73 364.526 321.96 361.81 333.001 363.762C337.829 364.614 341.113 366.123 344.272 367.561C348.23 369.371 351.976 371.075 358.455 371.572C370.117 372.495 380.5 369.744 387.689 363.851C398.819 354.71 403.096 337.652 398.588 320.381L398.961 320.292C403.505 337.705 399.174 354.923 387.92 364.153C380.66 370.117 370.17 372.886 358.401 371.963C351.852 371.448 348.088 369.726 344.095 367.916C340.953 366.478 337.687 365.005 332.912 364.153C321.996 362.2 309.854 364.916 296.861 372.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.244 358.029L393.298 357.745C397.008 338.983 375.317 325.706 375.086 325.581L375.281 325.244C375.494 325.368 397.203 338.646 393.724 357.532C396.173 356.911 413.409 352.012 416.124 338.628L416.497 338.699C413.533 353.272 393.706 357.922 393.511 357.958L393.244 358.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.197 380.412C387.049 380.412 382.772 379.543 379.452 378.478C371.678 375.993 367.435 371.928 367.4 371.892L367.258 371.768L367.382 371.626C380.304 357.692 369.157 337.776 369.051 337.581L369.388 337.386C369.494 337.581 380.713 357.603 367.808 371.75C368.589 372.46 372.672 375.921 379.594 378.14C386.694 380.412 398.339 381.779 413.444 375.46L413.586 375.815C405.385 379.241 398.196 380.412 392.197 380.412Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M377.996 391.95L175.661 461.744L52.4921 440.213C48.6581 439.538 45.8535 436.219 45.8535 432.314V392.837C45.8535 388.79 49.0663 385.489 53.1134 385.347L273.305 378.389L377.996 391.95Z",
    fill: "#BFC8D6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.416 389.287L171.1 410.144V457.43L53.416 437V389.287Z",
    fill: "#D8DEE8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.992 455.123V410.836C167.992 406.86 171.436 403.452 175.66 403.221L376.522 391.861C380.25 391.648 383.249 394.488 383.249 398.198V439.556C383.249 443.266 380.25 446.496 376.522 446.762L175.66 461.744C171.418 462.063 167.992 459.099 167.992 455.123Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M188.76 416.321C188.76 418.984 186.47 421.273 183.63 421.451C180.79 421.628 178.5 419.605 178.5 416.942C178.5 414.28 180.808 411.99 183.63 411.813C186.47 411.653 188.76 413.676 188.76 416.321Z",
    fill: "#BFC8D6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M204.895 415.344C204.895 417.989 202.623 420.261 199.819 420.439C197.014 420.616 194.725 418.61 194.725 415.966C194.725 413.321 196.997 411.031 199.819 410.871C202.623 410.694 204.895 412.7 204.895 415.344Z",
    fill: "#BFC8D6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M220.851 414.369C220.851 416.996 218.597 419.268 215.828 419.445C213.041 419.623 210.787 417.617 210.787 414.99C210.787 412.345 213.041 410.073 215.828 409.913C218.615 409.754 220.851 411.742 220.851 414.369Z",
    fill: "#BFC8D6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M372.546 438.224L230.863 448.377V409.025L372.546 400.611V438.224Z",
    fill: "url(#paint9_linear_291_3005)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.886 444.597L240.555 444.899V413.179L244.886 412.913V444.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.571 444.064L248.258 444.366V412.7L252.571 412.451V444.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.239 443.514L255.926 443.816V412.238L260.239 411.972V443.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.854 442.982L263.576 443.284V411.777L267.854 411.511V442.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.434 442.449L271.174 442.733V411.315L275.434 411.049V442.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.979 441.899L278.736 442.201V410.854L282.979 410.605V441.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.486 441.384L286.262 441.668V410.392L290.486 410.144V441.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.959 440.852L293.752 441.154V409.949L297.959 409.683V440.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.396 440.319L301.207 440.621V409.487L305.396 409.238V440.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.798 439.805L308.627 440.089V409.044L312.798 408.777V439.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.165 439.272L316.029 439.573V408.581L320.165 408.333V439.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.495 438.757L323.377 439.059V408.138L327.495 407.89V438.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.792 438.242L330.691 438.526V407.694L334.792 407.445V438.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.051 437.728L337.969 438.012V407.25L342.051 407.002V437.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.276 437.213L345.229 437.497V406.807L349.276 406.559V437.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.481 436.715L352.434 436.999V406.38L356.481 406.132V436.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.635 436.201L359.623 436.485V405.937L363.635 405.688V436.201Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.886 444.596L240.555 444.898V417.9L244.886 417.634V444.596Z",
    fill: "url(#paint10_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.571 444.064L248.258 444.365V441.117L252.571 440.815V444.064Z",
    fill: "url(#paint11_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.239 443.514L255.926 443.816V425.427L260.239 425.143V443.514Z",
    fill: "url(#paint12_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.854 442.981L263.576 443.283V435.348L267.854 435.064V442.981Z",
    fill: "url(#paint13_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.434 442.449L271.174 442.733V422.498L275.434 422.214V442.449Z",
    fill: "url(#paint14_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.979 441.898L278.736 442.2V428.284L282.979 428V441.898Z",
    fill: "url(#paint15_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.486 441.384L286.262 441.668V417.546L290.486 417.279V441.384Z",
    fill: "url(#paint16_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.959 440.851L293.752 441.153V414.598L297.959 414.332V440.851Z",
    fill: "url(#paint17_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.396 440.319L301.207 440.62V427.379L305.396 427.095V440.319Z",
    fill: "url(#paint18_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.798 439.804L308.627 440.088V411.155L312.798 410.906V439.804Z",
    fill: "url(#paint19_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.165 439.271L316.029 439.573V414.989L320.165 414.723V439.271Z",
    fill: "url(#paint20_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.495 438.757L323.377 439.059V432.473L327.495 432.189V438.757Z",
    fill: "url(#paint21_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.792 438.242L330.691 438.526V423.119L334.792 422.853V438.242Z",
    fill: "url(#paint22_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.051 437.727L337.969 438.011V415.841L342.051 415.593V437.727Z",
    fill: "url(#paint23_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.276 437.213L345.229 437.497V421.38L349.276 421.113V437.213Z",
    fill: "url(#paint24_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.481 436.715L352.434 436.999V412.043L356.481 411.776V436.715Z",
    fill: "url(#paint25_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.635 436.201L359.623 436.485V408.812L363.635 408.563V436.201Z",
    fill: "url(#paint26_linear_291_3005)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.137 380.874L172.164 400.63L378.032 335.912C378.6 335.735 378.511 334.901 377.925 334.847C360.157 333.303 262.105 324.801 261.554 324.801L53.7878 331.812C49.4035 331.865 45.8712 335.433 45.8712 339.817V373.472C45.8534 377.146 48.516 380.27 52.137 380.874Z",
    fill: "#BFC8D6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.416 337.563L174.26 348.657V397.542C174.26 397.542 53.416 380.253 53.416 377.874C53.416 375.513 53.416 337.563 53.416 337.563Z",
    fill: "#D8DEE8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M167.992 394.453V350.166C167.992 346.19 171.436 342.853 175.66 342.693L376.522 335.061C380.25 334.919 383.249 337.812 383.249 341.522V382.88C383.249 386.59 380.25 389.767 376.522 389.962L175.66 401.216C171.418 401.447 167.992 398.429 167.992 394.453Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188.76 356.042C188.76 358.704 186.47 360.941 183.63 361.065C180.79 361.189 178.5 359.13 178.5 356.468C178.5 353.805 180.808 351.551 183.63 351.444C186.47 351.338 188.76 353.397 188.76 356.042Z",
    fill: "#BFC8D6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.895 355.367C204.895 358.012 202.623 360.248 199.819 360.373C197.014 360.497 194.725 358.438 194.725 355.793C194.725 353.148 196.997 350.894 199.819 350.788C202.623 350.663 204.895 352.722 204.895 355.367Z",
    fill: "#BFC8D6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M220.851 354.693C220.851 357.32 218.597 359.556 215.828 359.681C213.041 359.805 210.787 357.764 210.787 355.119C210.787 352.474 213.041 350.255 215.828 350.131C218.615 350.024 220.851 352.066 220.851 354.693Z",
    fill: "#BFC8D6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M372.546 381.353L230.863 388.879V349.527L372.546 343.74V381.353Z",
    fill: "url(#paint27_linear_291_3005)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.886 385.365L240.555 385.596V353.858L244.886 353.681V385.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.571 384.957L248.258 385.188V353.539L252.571 353.344V384.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.239 384.566L255.926 384.779V353.201L260.239 353.023V384.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.854 384.158L263.576 384.388V352.882L267.854 352.704V384.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.434 383.767L271.174 383.998V352.562L275.434 352.385V383.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.979 383.377L278.736 383.59V352.243L282.979 352.065V383.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.486 382.987L286.262 383.2V351.924L290.486 351.746V382.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.959 382.595L293.752 382.808V351.603L297.959 351.426V382.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.396 382.205L301.207 382.418V351.302L305.396 351.124V382.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.798 381.814L308.627 382.027V350.982L312.798 350.805V381.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.165 381.442L316.029 381.655V350.663L320.165 350.503V381.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.495 381.051L323.377 381.264V350.361L327.495 350.184V381.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.792 380.679L330.691 380.892V350.042L334.792 349.882V380.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.051 380.288L337.969 380.501V349.74L342.051 349.562V380.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.276 379.915L345.229 380.128V349.438L349.276 349.261V379.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.481 379.543L352.434 379.756V349.136L356.481 348.959V379.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.635 379.17L359.623 379.383V348.835L363.635 348.657V379.17Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.886 385.365L240.555 385.596V358.58L244.886 358.402V385.365Z",
    fill: "url(#paint28_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.571 384.957L248.258 385.188V381.94L252.571 381.727V384.957Z",
    fill: "url(#paint29_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.239 384.567L255.926 384.78V366.391L260.239 366.195V384.567Z",
    fill: "url(#paint30_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.854 384.159L263.576 384.389V376.455L267.854 376.26V384.159Z",
    fill: "url(#paint31_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.434 383.767L271.174 383.998V363.745L275.434 363.55V383.767Z",
    fill: "url(#paint32_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.979 383.377L278.736 383.59V369.674L282.979 369.461V383.377Z",
    fill: "url(#paint33_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.486 382.987L286.262 383.2V359.077L290.486 358.882V382.987Z",
    fill: "url(#paint34_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.959 382.596L293.752 382.809V356.255L297.959 356.077V382.596Z",
    fill: "url(#paint35_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.396 382.205L301.207 382.418V369.177L305.396 368.981V382.205Z",
    fill: "url(#paint36_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.798 381.815L308.627 382.028V353.113L312.798 352.936V381.815Z",
    fill: "url(#paint37_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.165 381.442L316.029 381.655V357.071L320.165 356.894V381.442Z",
    fill: "url(#paint38_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.495 381.052L323.377 381.265V374.697L327.495 374.484V381.052Z",
    fill: "url(#paint39_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.792 380.68L330.691 380.893V365.468L334.792 365.272V380.68Z",
    fill: "url(#paint40_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.051 380.289L337.969 380.502V358.332L342.051 358.154V380.289Z",
    fill: "url(#paint41_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.276 379.916L345.229 380.129V363.994L349.276 363.816V379.916Z",
    fill: "url(#paint42_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.481 379.543L352.434 379.756V354.8L356.481 354.622V379.543Z",
    fill: "url(#paint43_linear_291_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.635 379.17L359.623 379.383V351.693L363.635 351.516V379.17Z",
    fill: "url(#paint44_linear_291_3005)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M492.432 283.141V448.04C492.432 450.508 490.32 451.058 487.941 451.182L408.154 456.418L406.965 456.472C404.551 456.578 402.562 454.643 402.562 452.158V285.839C402.562 283.354 404.551 281.259 406.965 281.188L408.562 281.135L488.669 282.466C491.065 282.395 492.432 280.673 492.432 283.141Z",
    fill: "url(#paint45_linear_291_3005)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M494.97 282.981V448.005C494.97 450.472 493.018 452.584 490.639 452.691L409.396 456.436C406.964 456.542 404.994 454.608 404.994 452.123V285.679C404.994 283.194 406.982 281.099 409.396 281.028L490.639 278.632C493.035 278.561 494.97 280.513 494.97 282.981Z",
    fill: "url(#paint46_linear_291_3005)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M492.291 292.21V444.969C492.291 447.277 490.462 449.247 488.244 449.336L411.847 452.832C409.592 452.939 407.729 451.128 407.729 448.803V294.82C407.729 292.494 409.575 290.542 411.847 290.471L488.244 288.146C490.462 288.092 492.291 289.921 492.291 292.21Z",
    fill: "url(#paint47_linear_291_3005)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M451.695 284.774C451.695 285.626 451.021 286.354 450.187 286.371C449.352 286.389 448.678 285.715 448.678 284.863C448.678 284.011 449.352 283.283 450.187 283.265C451.021 283.247 451.695 283.922 451.695 284.774Z",
    fill: "#DE8BDF"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.593 378.601C461.191 359.981 441.222 364.383 435.009 345.568C429.933 330.214 441.222 321.214 436.802 303.429C434.317 293.453 428.211 286.033 421.98 280.673L409.609 281.046C407.123 281.117 405.064 283.211 405.064 285.696V451.98C405.064 454.465 407.106 456.294 409.609 456.027L471.823 449.495C466.835 441.614 464.83 434.425 464.12 428.461C461.546 406.7 475.373 395.659 468.593 378.601Z",
    fill: "white"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M339.229 25.9049C364.559 27.2361 385.983 49.9032 387.066 76.5463C387.173 79.0846 387.084 81.5696 386.818 83.9837C391.202 82.2619 396.066 81.4276 401.213 81.7116C422.123 82.8121 439.802 101.521 440.69 123.496C441.542 144.388 426.951 160.718 407.55 161.357C406.538 161.392 405.509 161.375 404.461 161.321L231.184 151.648C221.421 149.269 213.735 139.968 213.291 129.229C212.794 117.141 221.723 107.84 233.207 108.443C235.639 108.568 238 109.136 240.201 110.059C239.207 106.278 238.585 102.355 238.426 98.3614C237.307 70.813 257.614 49.6014 283.813 50.9682C288.677 51.2167 293.398 52.2462 297.889 53.9147C303.96 36.5373 319.952 24.8931 339.229 25.9049Z",
    fill: "#413974"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M350.218 16.8873C375.547 18.2186 396.972 40.8856 398.054 67.5287C398.161 70.067 398.072 72.552 397.806 74.9661C402.19 73.2443 407.054 72.41 412.201 72.6941C433.111 73.7946 450.79 92.5033 451.678 114.478C452.53 135.37 437.939 151.7 418.538 152.339C417.526 152.375 416.497 152.357 415.45 152.304L242.172 142.63C232.409 140.251 224.723 130.95 224.28 120.211C223.783 108.124 232.711 98.8224 244.195 99.4259C246.627 99.5502 248.988 100.118 251.189 101.041C250.195 97.2604 249.574 93.3376 249.414 89.3438C248.296 61.7954 268.602 40.5839 294.801 41.9506C299.665 42.1991 304.386 43.2286 308.877 44.8972C314.948 27.5197 330.941 15.8755 350.218 16.8873Z",
    fill: "url(#paint48_linear_291_3005)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M237.716 329.025C232.497 329.167 227.421 327.871 223.019 325.226C209.599 317.185 189.79 303.908 171.951 286.531C149.32 264.467 136.326 242.048 133.486 220.038L133.433 219.701L132.883 125.731C132.883 107.164 144.988 92.0943 167.727 82.1897C186.506 74.0068 211.41 69.9597 237.716 70.723C263.72 71.4685 287.771 76.8468 305.575 85.7752C326.733 96.4076 337.845 111.336 337.845 129.033L337.348 218.796L337.312 219.133C334.721 240.22 322.757 262.017 301.617 284.045C284.665 301.725 265.495 315.73 252.342 324.41C247.958 327.267 242.917 328.865 237.716 329.025Z",
    fill: "url(#paint49_linear_291_3005)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M242.882 329.024C237.734 329.166 232.729 327.871 228.38 325.226C215.138 317.185 195.578 303.908 177.987 286.53C155.657 264.467 142.824 242.048 140.019 220.038L139.984 219.701L139.434 125.749C139.434 107.182 151.379 92.1119 173.816 82.2072C192.347 74.0244 216.913 69.9773 242.882 70.7406C268.531 71.4861 292.281 76.8644 309.836 85.7928C330.728 96.4252 341.68 111.353 341.68 129.05L341.183 218.813L341.147 219.15C338.574 240.238 326.787 262.035 305.913 284.063C289.175 301.742 270.271 315.747 257.277 324.427C252.982 327.267 248.012 328.865 242.882 329.024Z",
    fill: "url(#paint50_linear_291_3005)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M145.627 125.802L146.177 219.275C152.337 266.97 208.374 305.577 232.798 320.256C239.792 324.463 248.738 324.215 255.678 319.635C279.588 303.908 332.555 264.308 338.217 218.459L338.714 128.944C338.714 62.5228 145.627 56.4345 145.627 125.802Z",
    fill: "url(#paint51_linear_291_3005)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M244.265 305.843C243.821 305.861 243.147 305.772 242.455 305.364C232.408 299.275 212.918 286.531 195.967 269.881C177.666 251.9 167.105 234.416 164.673 217.979L164.141 126.051C164.158 117.229 171.152 109.685 184.837 103.65C200.12 96.9049 221.811 93.3726 244.265 93.9051C266.489 94.4376 287.558 98.9107 302.149 106.153C315.053 112.561 321.585 120.104 321.603 128.625L321.106 217.376C318.852 233.262 308.929 250.409 291.534 268.408C275.168 285.341 256.051 298.761 246.076 305.293C245.383 305.719 244.709 305.825 244.265 305.843Z",
    fill: "url(#paint52_linear_291_3005)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M241.975 299.559C231.822 293.311 213.77 281.241 198.026 265.745C180.826 248.811 170.868 232.57 168.525 217.518L167.992 126.122C168.01 119.82 173.797 114.034 185.174 108.993C199.641 102.585 220.391 99.2121 241.975 99.6914C263.364 100.171 283.511 104.395 297.374 111.247C308.13 116.572 313.58 122.376 313.597 128.536L313.1 216.95C310.899 231.54 301.51 247.498 285.091 264.467C269.825 280.211 252.075 292.885 241.975 299.559Z",
    fill: "#F4F7FA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M278.292 179.905L209.936 180.508C204.682 180.562 200.404 184.644 200.404 189.65V233.44C200.404 238.41 204.664 242.261 209.901 242.048L278.008 239.262C282.854 239.066 286.777 235.055 286.812 230.298L287.025 188.46C287.043 183.703 283.156 179.852 278.292 179.905Z",
    fill: "url(#paint53_linear_291_3005)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M253.459 205.004C253.477 200.176 249.323 196.342 244.247 196.661C239.756 196.945 236.028 200.566 235.78 204.915C235.585 208.288 237.413 211.216 240.182 212.69C241.371 213.329 241.939 214.642 241.708 215.956L239.738 227.014C239.49 228.416 240.608 229.659 242.081 229.606L247.087 229.428C248.542 229.375 249.661 228.061 249.412 226.677L247.495 215.725C247.264 214.411 247.939 213.116 249.128 212.406C251.72 210.879 253.459 208.128 253.459 205.004Z",
    fill: "url(#paint54_linear_291_3005)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.334 175.556C275.275 175.574 273.624 173.941 273.624 171.918L273.66 162.386C273.695 152.8 265.779 144.919 255.91 144.831L233.598 144.618C223.374 144.511 214.978 152.481 214.978 162.368V172.202C214.978 174.296 213.203 176 211.002 176.018C208.801 176.036 207.008 174.349 207.008 172.237V162.35C207.008 148.221 219.042 136.879 233.615 137.074L255.927 137.376C269.95 137.571 281.151 148.789 281.08 162.368L281.026 171.864C281.044 173.888 279.376 175.539 277.334 175.556Z",
    fill: "url(#paint55_linear_291_3005)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M139.165 257.243C139.165 257.243 140.585 255.22 141.331 253.8C142.076 252.38 140.266 248.439 139.449 245.155C138.651 241.871 138.242 247.001 138.136 248.155C138.029 249.309 138.029 251.457 136.822 255.149L139.165 257.243Z",
    fill: "url(#paint56_linear_291_3005)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M130.042 454.91L129.492 463.732C129.492 463.732 130.752 465.063 133.149 464.14L135.776 455.478L130.042 454.91Z",
    fill: "url(#paint57_linear_291_3005)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M131.16 461.389C131.16 461.389 126.847 463.146 127.681 465.063C128.125 466.093 129.687 468.4 131.036 470.335C132.279 472.11 134.533 472.909 136.61 472.287C137.302 472.074 138.03 471.879 138.651 471.702C139.964 471.364 140.035 469.536 138.757 469.092C138.136 468.879 137.533 468.702 137 468.613C135.42 468.365 133.237 464.637 132.989 463.146C132.74 461.637 131.16 461.389 131.16 461.389Z",
    fill: "url(#paint58_linear_291_3005)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.777 370.294C127.131 372.495 150.65 381.37 155.887 401.765C156.171 402.848 156.881 405.883 156.916 410.818C157.058 431.39 145.077 448.821 136.379 458.939C133.628 458.885 130.894 458.85 128.143 458.797C126.776 453.543 125.516 445.697 127.486 436.857C130.504 423.349 138.314 419.835 136.805 413.214C134.072 401.179 106.115 402.99 103.47 392.215C102.529 388.328 104.624 381.725 120.777 370.294Z",
    fill: "url(#paint59_linear_291_3005)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1257 493.516L54.0716 493.232C54.7994 493.215 55.1189 492.292 54.5686 491.83C54.0183 491.369 53.2373 490.978 52.2611 491.085C49.989 491.315 44.8947 488.138 42.5872 488.83C41.8239 489.061 41.2204 490.836 40.9009 491.315C40.2619 492.274 40.9719 493.534 42.1257 493.516Z",
    fill: "url(#paint60_linear_291_3005)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4871 484.34L42.5703 488.813C42.5703 488.813 44.2921 490.091 46.7949 489.541L51.8182 486.079L47.4871 484.34Z",
    fill: "url(#paint61_linear_291_3005)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.864 423.404C145.166 414.493 149.124 403.523 144.598 397.293C140.018 390.992 130.007 396.317 119.96 391.222C116.233 389.341 112.399 385.968 109.221 379.862C103.577 385.684 102.814 389.589 103.47 392.234C106.097 403.009 134.072 401.198 136.805 413.233C138.314 419.871 130.504 423.368 127.486 436.876C125.8 444.473 126.492 451.343 127.593 456.455C128.569 451.698 130.096 446.71 132.421 441.669C136.024 433.876 138.403 432.776 141.864 423.404Z",
    fill: "url(#paint62_linear_291_3005)"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M124.415 367.738C120.545 385.506 112.291 412.646 93.4052 440.958C79.418 461.921 64.0463 476.867 51.9939 486.842C51.1419 487.091 49.6686 487.41 47.8758 487.197C46.5446 487.038 45.4795 486.629 44.7695 486.292C45.6038 481.287 47.3433 473.885 51.4969 465.897C59.094 451.271 65.8568 451.732 73.4894 438.828C79.0808 429.367 80.8913 419.338 84.5301 399.245C87.3346 383.731 87.3346 380.039 91.1864 375.584C98.9788 366.602 113.569 366.496 124.415 367.738Z",
    fill: "url(#paint63_linear_291_3005)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4273 469.199C57.1431 464.921 61.9534 460.465 71.4498 451.661C81.2656 442.573 80.8751 444.224 82.8099 441.526C91.4543 429.509 86.7682 416.658 88.916 401.162C90.1053 392.518 93.9216 381.211 105.051 368.555C99.8324 369.513 94.8446 371.59 91.2235 375.584C86.7682 380.501 87.0877 385.329 84.5672 399.245C80.9284 419.32 79.1179 429.367 73.5265 438.828C65.8939 451.732 59.1311 451.271 51.534 465.897C47.3804 473.885 45.6232 481.286 44.8066 486.292C45.5167 486.629 46.5817 487.038 47.9129 487.197C48.9602 487.322 49.901 487.268 50.682 487.144C50.0252 476.991 53.0605 471.364 54.4273 469.199Z",
    fill: "url(#paint64_linear_291_3005)"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M134.871 252.255C134.871 252.255 138.048 275.934 113.109 292.619L139.664 298.956C139.664 298.956 148.166 283.069 142.007 256.746L134.871 252.255Z",
    fill: "#F4F7FA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M109.842 274.781C111.138 272.207 111.688 272.225 112.007 270.876C112.735 267.787 110.854 263.864 109.256 263.811C108.227 263.776 108.138 265.373 105.955 267.876C103.292 270.929 101.659 270.538 100.097 273.183C99.7243 273.805 98.0735 276.591 99.0852 278.686C100.381 281.348 105.511 281.774 107.641 279.715C108.653 278.739 108.227 277.94 109.842 274.781Z",
    fill: "url(#paint65_linear_291_3005)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M106.008 277.549C106.008 277.549 106.931 282.43 106.274 286.389C105.689 289.974 99.0499 293.702 97.7719 294.767C96.4939 295.832 101.144 296.986 105.422 296.435C109.682 295.885 121.362 292.14 123.137 290.063C124.912 287.986 121.078 288.998 117.847 288.607C114.617 288.217 111.528 282.803 111.44 280.034C111.315 277.283 106.008 277.549 106.008 277.549Z",
    fill: "url(#paint66_linear_291_3005)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M107.394 281.188C107.394 281.188 110.66 282.626 113.554 280.301C116.145 278.224 112.293 271.869 109.666 271.781C108.779 271.745 107.501 272.384 106.755 273.307C106.312 273.858 106.276 274.213 105.531 275.082C104.838 275.881 104.536 275.97 104.43 276.36C104.306 276.857 104.519 277.674 106.294 279.076C105.406 278.916 104.643 279.147 104.359 279.662C104.306 279.751 104.217 279.999 104.235 280.265C104.341 281.242 105.584 281.685 107.394 281.188Z",
    fill: "url(#paint67_linear_291_3005)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M179.158 264.219C179.158 264.219 181.128 263.935 180.525 260.172C180.046 257.207 180.401 256.213 181.111 256.746C181.803 257.278 181.909 258.982 181.909 258.982C181.909 258.982 184.466 256.817 185.513 253.959C186.56 251.101 187.235 253.515 187.465 254.935C187.696 256.355 185.974 260.775 184.998 261.609C184.022 262.426 182.602 266.065 182.602 266.065L179.158 264.219Z",
    fill: "url(#paint68_linear_291_3005)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M184.429 265.23C182.175 263.651 179.938 262.071 177.684 260.509C174.95 277.336 168.72 283.939 163.448 286.832C150.704 293.808 139.326 281.383 114.919 286.442C108.192 287.844 96.4766 290.436 89.98 300.021C88.276 302.541 87.6724 304.441 84.8324 322.51C81.2114 345.603 81.0694 349.633 81.5841 354.603C82.5249 363.709 83.0929 369.211 87.2819 374.093C98.4291 387.05 122.108 380.376 125.072 379.489C130.557 377.856 139.077 375.335 142.467 368.093C144.065 364.685 143.887 361.561 141.438 349.1C136.592 324.392 135.971 322.794 137.32 320.096C141.882 310.973 156.366 316.191 168.596 307.707C175.731 302.737 183.79 291.927 184.429 265.23Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M113.944 376.205C116.34 371.306 113.128 366.798 116.642 360.904C121.133 353.396 129.192 355.952 132.245 350.414C137.445 340.935 116.997 327.712 121.151 312.624C123.139 305.417 130.061 300.199 135.848 298.228C148.699 293.844 157.095 305.027 169.13 301.53C171.987 300.696 175.253 298.992 178.573 295.424C175.644 301.601 172.005 305.328 168.579 307.725C156.349 316.209 141.865 310.991 137.303 320.114C135.954 322.812 136.576 324.41 141.421 349.118C143.871 361.597 144.048 364.703 142.451 368.111C139.061 375.353 130.541 377.891 125.056 379.507C123.423 379.986 115.595 382.205 107.021 381.992C110.838 380.412 112.897 378.353 113.944 376.205Z",
    fill: "#F4F7FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_291_3005",
    x1: 307.902,
    y1: 344.653,
    x2: 309.126,
    y2: 390.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_291_3005",
    x1: 317.888,
    y1: 287.624,
    x2: 183.09,
    y2: -185.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_291_3005",
    x1: 395.63,
    y1: 61.0881,
    x2: 165.193,
    y2: 327.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_291_3005",
    x1: 103.184,
    y1: 326.182,
    x2: 479.654,
    y2: 326.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_291_3005",
    x1: 122.979,
    y1: 159.823,
    x2: 69.7707,
    y2: 302.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_291_3005",
    x1: 87.2078,
    y1: 215.476,
    x2: 270.722,
    y2: 380.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_291_3005",
    x1: 361.026,
    y1: 260.181,
    x2: 306.692,
    y2: 334.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#6165D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA80F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_291_3005",
    x1: 382.79,
    y1: 269.474,
    x2: 339.41,
    y2: 398.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_291_3005",
    x1: 297.539,
    y1: 391.503,
    x2: 647.065,
    y2: 253.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_291_3005",
    x1: 259.062,
    y1: 400.597,
    x2: 346.243,
    y2: 449.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_291_3005",
    x1: 241.94,
    y1: 419.403,
    x2: 244.276,
    y2: 455.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_291_3005",
    x1: 250.321,
    y1: 441.108,
    x2: 250.603,
    y2: 445.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_291_3005",
    x1: 257.516,
    y1: 425.848,
    x2: 259.107,
    y2: 450.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_291_3005",
    x1: 265.457,
    y1: 435.326,
    x2: 266.143,
    y2: 445.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_291_3005",
    x1: 272.636,
    y1: 422.364,
    x2: 274.388,
    y2: 449.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_291_3005",
    x1: 280.385,
    y1: 427.932,
    x2: 281.59,
    y2: 446.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_291_3005",
    x1: 287.534,
    y1: 416.688,
    x2: 289.622,
    y2: 448.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_291_3005",
    x1: 294.905,
    y1: 413.267,
    x2: 297.203,
    y2: 448.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_291_3005",
    x1: 302.815,
    y1: 426.439,
    x2: 303.961,
    y2: 443.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_291_3005",
    x1: 309.622,
    y1: 408.86,
    x2: 312.125,
    y2: 447.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_291_3005",
    x1: 317.139,
    y1: 412.643,
    x2: 319.266,
    y2: 445.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_291_3005",
    x1: 325.17,
    y1: 431.635,
    x2: 325.74,
    y2: 440.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_291_3005",
    x1: 332.113,
    y1: 421.127,
    x2: 333.448,
    y2: 441.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_291_3005",
    x1: 339.09,
    y1: 412.718,
    x2: 341.008,
    y2: 441.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_291_3005",
    x1: 346.565,
    y1: 418.819,
    x2: 347.96,
    y2: 440.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_291_3005",
    x1: 353.367,
    y1: 407.775,
    x2: 355.527,
    y2: 440.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_291_3005",
    x1: 360.394,
    y1: 403.683,
    x2: 362.789,
    y2: 440.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_291_3005",
    x1: 258.668,
    y1: 342.192,
    x2: 346.661,
    y2: 391.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_291_3005",
    x1: 241.937,
    y1: 360.087,
    x2: 244.279,
    y2: 395.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_291_3005",
    x1: 250.32,
    y1: 381.952,
    x2: 250.605,
    y2: 386.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_291_3005",
    x1: 257.513,
    y1: 366.816,
    x2: 259.11,
    y2: 391.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_291_3005",
    x1: 265.455,
    y1: 376.447,
    x2: 266.146,
    y2: 386.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_291_3005",
    x1: 272.634,
    y1: 363.612,
    x2: 274.391,
    y2: 390.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_291_3005",
    x1: 280.382,
    y1: 369.324,
    x2: 281.592,
    y2: 387.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_291_3005",
    x1: 287.531,
    y1: 358.216,
    x2: 289.624,
    y2: 390.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_291_3005",
    x1: 294.903,
    y1: 354.933,
    x2: 297.205,
    y2: 390.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_291_3005",
    x1: 302.812,
    y1: 368.247,
    x2: 303.963,
    y2: 385.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_291_3005",
    x1: 309.619,
    y1: 350.801,
    x2: 312.127,
    y2: 389.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_291_3005",
    x1: 317.136,
    y1: 354.72,
    x2: 319.268,
    y2: 387.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_291_3005",
    x1: 325.168,
    y1: 373.862,
    x2: 325.742,
    y2: 382.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_291_3005",
    x1: 332.111,
    y1: 363.476,
    x2: 333.449,
    y2: 383.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_291_3005",
    x1: 339.087,
    y1: 355.2,
    x2: 341.01,
    y2: 384.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_291_3005",
    x1: 346.562,
    y1: 361.435,
    x2: 347.962,
    y2: 382.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_291_3005",
    x1: 353.364,
    y1: 350.525,
    x2: 355.529,
    y2: 383.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_291_3005",
    x1: 360.391,
    y1: 346.564,
    x2: 362.79,
    y2: 383.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_291_3005",
    x1: 511.928,
    y1: 423.152,
    x2: 435.365,
    y2: 357.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_291_3005",
    x1: 446.975,
    y1: 447.839,
    x2: 457.844,
    y2: 155.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_291_3005",
    x1: 475.564,
    y1: 335.544,
    x2: 378.031,
    y2: 466.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_291_3005",
    x1: 224.271,
    y1: 84.5937,
    x2: 451.732,
    y2: 84.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_291_3005",
    x1: 355.589,
    y1: 63.5235,
    x2: 296.515,
    y2: 120.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_291_3005",
    x1: 180.012,
    y1: 76.4615,
    x2: 380.82,
    y2: 404.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_291_3005",
    x1: 286.491,
    y1: 263.46,
    x2: 123.406,
    y2: -64.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_291_3005",
    x1: 164.139,
    y1: 199.842,
    x2: 321.607,
    y2: 199.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_291_3005",
    x1: 293.03,
    y1: 118.598,
    x2: 228.266,
    y2: 238.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_291_3005",
    x1: 235.781,
    y1: 213.14,
    x2: 253.464,
    y2: 213.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_291_3005",
    x1: 274.316,
    y1: 108.475,
    x2: 209.553,
    y2: 228.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_291_3005",
    x1: 207.364,
    y1: 120.757,
    x2: 187.937,
    y2: 157.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_291_3005",
    x1: 128.872,
    y1: 460.037,
    x2: 136.35,
    y2: 458.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_291_3005",
    x1: 138.079,
    y1: 426.763,
    x2: 130.18,
    y2: 498.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_291_3005",
    x1: 152.768,
    y1: 394.562,
    x2: 88.4426,
    y2: 447.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_291_3005",
    x1: 76.4499,
    y1: 418.53,
    x2: 53.1368,
    y2: 478.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_291_3005",
    x1: 42.7738,
    y1: 486.671,
    x2: 51.6849,
    y2: 487.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_291_3005",
    x1: 182.298,
    y1: 439.724,
    x2: 102.831,
    y2: 412.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_291_3005",
    x1: 99.8795,
    y1: 394.388,
    x2: 54.0025,
    y2: 486.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_291_3005",
    x1: 94.1407,
    y1: 394.004,
    x2: 49.2165,
    y2: 484.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_291_3005",
    x1: 105.333,
    y1: 277.623,
    x2: 105.889,
    y2: 258.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_291_3005",
    x1: 106.605,
    y1: 232.877,
    x2: 111.774,
    y2: 310.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_291_3005",
    x1: 94.9604,
    y1: 268.764,
    x2: 113.284,
    y2: 280.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_291_3005",
    x1: 158.513,
    y1: 88.6411,
    x2: 164.95,
    y2: 133.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_291_3005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 497.007,
    fill: "white",
    transform: "translate(1 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSecurity);
export default __webpack_public_path__ + "static/media/Cloud-Security.fe77557b27478cd14a0374343789f31b.svg";
export { ForwardRef as ReactComponent };